import type { FaireProductEntity } from "../../entity_types/product";

export const p_aqw92qdw6w: FaireProductEntity = {
  token: "p_aqw92qdw6w",
  type: "product",
  name: "Bitty Blooms White Cardigan Sweater Baby & Toddler",
  brandToken: "b_e6gi5qy7n8",
  brandName: "Huggalugs",
  imageUrl:
    "https://cdn.faire.com/fastly/8b10bd2ee3193b5a1630f0af06103602ad5b9e636ebe8291b728c566af7d044f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5368eb37e2637756e2de5dd1ca17d9639659b192200fc3be2a769587248827e6.jpeg",
    "https://cdn.faire.com/fastly/4a2001c43d56aaa8dd77844d5a7851d86a570c06b4126f15d1b72c1a4e681661.png",
    "https://cdn.faire.com/fastly/1f29cd5fc2f2b65d29f76b370ce324125e4c3e1204fa5b81cc81cac870f1d244.jpeg",
  ],
  priceDollars: 34,
  description:
    "This beautiful sweater is knit with pretty blush pink flowers and mint green leaves. It's thick and cozy and styled with raglan sleeves and wood buttons. We also offer a matching Bitty Blooms beanie hat if you want to match this up.  What a wonderful gift for any little girl you know.\nOur sweaters are partially knit from recycled, sustainable Polyester yarn made from plastic bottles. We are on a mission to help reduce the world's plastic pollution problem ♻\n• Hand Knit in China\n• 60% Acrylic, 40% Recycled Polyester\n• Hand Wash",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:13.609Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
